import axios from 'axios';
import moment from 'moment';
// socket.js
import io from 'socket.io-client';

// const socket = io("https://websocketlinux2023.ihs-w.com",{
// const socket = io("https://iconntestlinux2023.ihs-w.com",{
// // const socket = io("https://iconntest.hrd-s.com",{ // OLD ICONN LINK - UPDATED 20260603
//     transports: ["websocket"]
// });

    export function updateBossCadRequest(stat, bossData, updateStatus){
        axios({
            method: "POST",
            url: "api/update_cad_boss",
            data: {
                sent_at : moment().format('YYYY-MM-DD HH:mm:ss'),
                sent_to_boss : stat ? 1 : 0,
                bossData : bossData,
                update: updateStatus
            }
        }).then(({data}) => {
            console.log(data, 'data')
        })
    }


    export function sendToBoss(data){
        
        let formData = new FormData();

        formData.append("hrdId", data.HRD_ID);
        formData.append("customerCode", data.code_number);
        formData.append("planType", data.boss_code);
        formData.append("receivedDay", data.received_day ? moment(data.received_day).format('YYYY/MM/DD HH:mm:ss') : '');
        formData.append("planNumber", data.plan_number);
        formData.append("finishPlanDay", data.finish_day ? moment(data.finish_day).format('YYYY/MM/DD HH:mm:ss') : '');
        formData.append("finishedDay", data.finish_day ? moment(data.finish_day).format('YYYY/MM/DD HH:mm:ss') : '');
        // formData.append("path", null);
        formData.append("remarks", data.remarks);
        formData.append("plannerCode", "");
        formData.append("file", data.file);
        formData.append("action", data.status);
        formData.append("cad_id", data.id);

        // console.log(formData);
        // return;
        // let sendToBossData = {
        //     hrdId : 'CRS35720230902OIMC4',
        //     customerCode : '0000000-0000',
        //     planType : '357',
        //     receivedDay : 'test',
        //     planNumber : 'test',
        //     finishPlanDay : 'test',
        //     finishedDay : 'test',
        //     remarks : 'test',
        //     plannerCode : "",
        //     // file : 'PDF/0000000-0000/0000000-0000-0100-20230830165421-357.pdf',
        //     file : 'PDF/0000000-0040/0000000-0040-(0409A)-202307123451-357.pdf',
        //     action : 'UPDATE',
        //     // cad_id: newdata.id
        // }

        const config = {
            headers: { "Content-Type": "multipart/form-data" },
        };
        //  SEND TO BOSS

        axios({
                method: 'POST',
                url: `api/send_to_boss`,
                data : formData,
            //   config
            }).then((res) => {
                console.log(res.data)
            })
    }

    export function generateHRDID(code){
        // generate HRDID
        // format CRSdatetoday5Randomletterornumber
        let dateToday =  moment().format('YYYYMMDD')
        const randomChars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
        let randomPart = '';
        for (let i = 0; i < 5; i++) {
            const randomIndex = Math.floor(Math.random() * randomChars.length);
            randomPart += randomChars.charAt(randomIndex);
        }
        let HRDID = 'CRS'+ code + dateToday + randomPart;
        // console.log(HRDID)
        return HRDID;
    }
    
    export async function getZumenType(bossCode){
        try {
            const response = await axios.get(`api/zumen_type/${bossCode}`);
            if (response.data) {
                return response.data;
            }
        } catch (error) {
            console.error('Error fetching zumen type:', error);
            throw error; // Rethrow the error to be caught by the calling code
        }
    }

    export async function getZumenTypeMultiple(bossCode){
        let zumen = []
        try {
            await axios.post(`api/zumen_type_multi`, {
                boss : bossCode
            }).then(({data}) => {
                if (data) {
                    zumen = data;
                }
            });

        } catch (error) {
            console.error('Error fetching zumen type:', error);
            throw error; // Rethrow the error to be caught by the calling code
        }

        return zumen;
    }

    export function formatDate(createdDate) {
        const date = new Date(createdDate);
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        const daysOfWeek = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
        const dayOfWeek = daysOfWeek[date.getDay()];
        const hours = String(date.getHours() % 12 || 12).padStart(2, '0');
        const minutes = String(date.getMinutes()).padStart(2, '0');
        const meridiem = date.getHours() >= 12 ? 'PM' : 'AM';
    
        const formattedDate = `${year}-${month}-${day}`;
        const formattedDay = dayOfWeek;
        const formattedTime = `${hours}:${minutes} ${meridiem}`;
    
        return {
            date: formattedDate,
            day: formattedDay,
            time: formattedTime,
        };
    }

    export async function getBundleSchedule(createdDate){
        const formatted = formatDate(createdDate);
        // axios({
        //     method: "POST",
        //     url: "api/bundle_schedule",
        //     data: {
        //         date: moment(createdDate).format('YYYY-MM-DD'),
        //         day : moment(createdDate).format('ddd'),
        //         time : moment(createdDate).format('h:mm')
        //     }
        // }).then(({data}) => {
        //     if(data){
        //         console.log(data.bracket_name)
        //         return data
        //     }
        // })
        try {
            const response = await axios.post(`api/bundle_schedule`, {
                    date: formatted.date,
                    day : formatted.day,
                    time : formatted.time
                });
            if (response.data) {
                return response.data;
            }
        } catch (error) {
            console.error(error);
            throw error; // Rethrow the error to be caught by the calling code
        }
    }

    export async function saveToXML(bossData, isNewExpress, latest, basicInfo, planner, salesman, house, ci, power, userInfo, regDate){
        // await axios({
        //     method: "POST",
        //     url: "api/sendToCadReqXML",
        //     data : {
        //         bossSendingData : bossData
        //     }
        // }).then(({data}) => {
        //     if(data) return data;
        // })

        try {
            const response = await axios.post(`api/sendToCadReqXML`, {
                bossSendingData : bossData, 
                isNewExpressPlan: isNewExpress,
                cadData: latest,
                basic: basicInfo,
                plannerDetails: planner,
                salesmanDetails: salesman,
                house_type: house,
                fromCi: ci,
                powerId: power,
                user: userInfo,
                register_date : regDate,
            });
            if (response.data) {
                return response.data;
            }
        } catch (error) {
            console.error(error);
            throw error; // Rethrow the error to be caught by the calling code
        }
    }

    export async function updateXML(cad_request, status){

        try {
            const response = await axios.post(`api/update_cad_req_XML`, {
                cadRequestData : cad_request,
                status: status,
            });
            if (response.data) {
                return response.data;
            }
        } catch (error) {
            console.error(error);
            throw error; // Rethrow the error to be caught by the calling code
        }
    }

    export async function removeHrdAccept(cad_request){
        try {
            const response = await axios.post(`api/remove_hrd_accept`, {
                id : cad_request[0].cad_id,
            });
            if (response.data) {
                return response.data;
            }
        } catch (error) {
            console.error(error);
            throw error; // Rethrow the error to be caught by the calling code
        }
    }
